// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"b226e589","187":"e5f8809b","239":"edc2b42c","453":"366359a2","455":"4f64cc62","796":"0f8b5dc3","906":"2d8cda9e","946":"b2ae6cdf"}[chunkId] + ".chunk.js";
};